@if (loading()) {
  <div class="score-container mt-10">
    <div class="card validations-card">
      <div class="h-6 w-32 bg-(--color-bg-secondary) rounded mb-4 animate-pulse"></div>
      <div class="space-y-3">
        @for (i of [1,2,3,4]; track i) {
          <div class="flex items-center gap-3">
            <div class="w-6 h-6 bg-(--color-bg-secondary) rounded animate-pulse"></div>
            <div class="flex-1 space-y-2">
              <div class="h-4 w-48 bg-(--color-bg-secondary) rounded animate-pulse"></div>
              <div class="h-3 w-64 bg-(--color-bg-secondary) rounded animate-pulse"></div>
            </div>
          </div>
        }
      </div>
    </div>
    <div class="card score-card">
      <div class="h-6 w-32 bg-(--color-bg-secondary) rounded mb-4 animate-pulse"></div>
      <div class="donut-container">
        <div class="w-32 h-32 bg-(--color-bg-secondary) rounded-full animate-pulse"></div>
      </div>
      <div class="space-y-3 mt-6">
        @for (i of [1,2,3]; track i) {
          <div class="space-y-2">
            <div class="h-4 w-32 bg-(--color-bg-secondary) rounded animate-pulse"></div>
            <div class="h-3 bg-(--color-bg-secondary) rounded animate-pulse w-80/100"></div>
          </div>
        }
      </div>
    </div>
  </div>
} @else {
  <div class="score-container mt-10">
    <div class="card validations-card">
      <h3 class="card-title">{{ 'score.title' | translate }}</h3>
      <div class="location-scores">
        <div class="location-score-item">
          <div class="location-score-header">
            <span class="location-score-label">{{ 'score.userLocation' | translate }}</span>
            <span class="location-score-value" [class]="locationScore().color">{{ locationScore().score }}</span>
          </div>
          <div class="bar-track">
            <div class="bar-fill" [class]="locationScore().color" [style.width.%]="locationScore().score !== 'N/A' ? locationScore().score : 0"></div>
          </div>
        </div>
        <div class="location-score-item">
          <div class="location-score-header">
            <span class="location-score-label">{{ 'score.formLocation' | translate }}</span>
            <span class="location-score-value" [class]="formularioScore().color">{{ formularioScore().score }}</span>
          </div>
          <div class="bar-track">
            <div class="bar-fill" [class]="formularioScore().color" [style.width.%]="formularioScore().score !== 'N/A' ? formularioScore().score : 0"></div>
          </div>
        </div>
        <div class="location-score-item">
          <div class="location-score-header">
            <span class="location-score-label">{{ 'score.evidenceLocation' | translate }}</span>
            <span class="location-score-value" [class]="evidenciasScore().color">{{ evidenciasScore().score }}</span>
          </div>
          <div class="bar-track">
            <div class="bar-fill" [class]="evidenciasScore().color" [style.width.%]="evidenciasScore().score !== 'N/A' ? evidenciasScore().score : 0"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="card score-card">
      <h3 class="card-title">{{ 'score.totalScore' | translate }}</h3>
      <div class="donut-container">
        <svg viewBox="0 0 120 120" class="donut-svg">
          <circle cx="60" cy="60" r="54" fill="none" stroke="#e5e7eb" stroke-width="12" />
          <circle
            cx="60" cy="60" r="54" fill="none"
            [attr.stroke]="getDonutColor()"
            stroke-width="12"
            stroke-linecap="round"
            [attr.stroke-dasharray]="getDonutDashArray()"
            transform="rotate(-90 60 60)"
            class="donut-fill"
          />
        </svg>
        <div class="donut-center">
          <span class="donut-score">{{ getTotalScore() }}</span>
          <span class="donut-label">{{ 'score.points' | translate }}</span>
        </div>
      </div>
    </div>
  </div>
}
